import { render, staticRenderFns } from "./enclosure.vue?vue&type=template&id=46340b8c&scoped=true&"
import script from "./enclosure.vue?vue&type=script&lang=js&"
export * from "./enclosure.vue?vue&type=script&lang=js&"
import style0 from "./enclosure.vue?vue&type=style&index=0&id=46340b8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46340b8c",
  null
  
)

export default component.exports